import api from 'shared/api';

export const resetLicense = (licenseId, data) => {
  const url = `/api/v1/licenses/${licenseId}/reset/`;
  return api.post(url, data);
};
